<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">
          全部消息({{ messageList.length }})
        </li>
        <!-- <li :class="{ active: tabIndex === 1 }" @click="changeTab(1)">
          已读消息({{ messageListB.length }})
        </li> -->
        <!-- <li :class="{ active: tabIndex === 2 }" @click="changeTab(2)">
          课程更新({{ messageWithCourseListA.length }})
        </li> -->
        <!-- <li :class="{ active: tabIndex === 3 }" @click="changeTab(3)">
          串讲上线({{ messageWithCourseListB.length }})
        </li> -->
      </ul>
    </div>
    <div class="member-main-body">
      <div class="no-data" v-show="messageList.length == 0">
        <img src="../../assets/no-data.png" />
        <p>暂无消息</p>
      </div>
      <div class="message-list" v-show="messageList.length > 0">
        <div
          class="message-item"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="item-icon">
            <i class="el-icon-message-solid"></i>
          </div>
          <div class="item-content">
            <p @click="showDetail(item)" :class="(item.isread == 1 ?'is-read':'')">
              {{ item.title }}<span>{{ item.create_time }}</span>
            </p>
            <p v-html="item.content"></p>
          </div>
          <!-- <div class="item-action">
            <Poptip
              confirm
              title="您确定要删除当前信息么?"
              @on-ok="deleteMessage(item.unid)"
              popper-class="tip-width"
              placement="top-end"
            >
              <div class="delete-icon">
                <Icon custom="ich-icon ich-icon-delete" size="22"></Icon>
              </div>
            </Poptip>
          </div> -->
          <Drawer
            :title="item.title"
            width="640"
            :closable="false"
            v-model="item.detailVisible"
          >
            <div v-html="item.content"></div>
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetMemberNoticeList, GetMemberNotice } from "../../api/api";
export default {
  data() {
    return {
      tabIndex: 0,
      isRead: 0,
      messageType: 1,
      messageList: [],
      courseType: -1,
      messageWithCourseListA: [],
      messageWithCourseListB: [],
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    getMessage() {
      GetMemberNoticeList().then((res) => {
        if (res.code === 1) {
          this.messageList = res.data.list;
          this.messageList.forEach((item) => {
            this.$set(item, "detailVisible", false);
          });
        }
      });
    },
    showDetail(item) {
      item.detailVisible = true;
      GetMemberNotice({id:item.id}).then((res) => {
        // console.log(res);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.message-list {
  padding: 0 30px 30px 30px;
  .message-item {
    display: flex;
    padding: 30px 0;
    border-bottom: 1px dashed #ececec;
    .item-icon {
      width: 52px;
      height: 52px;
      background: #f8f8f8;
      border-radius: 50px;
      color: #41a5fd;
      text-align: center;
      line-height: 52px;
      i{
        font-size:22px;
      }
    }
    .item-content {
      flex: 1;
      margin-left: 10px;
      p {
        font-size:16px;
        &:first-child {
          font-weight: bold;
          cursor: pointer;
          span {
            font-size: 12px;
            color: #666;
            margin-left: 10px;
            font-weight: normal;
          }
        }
        &:last-child {
          margin-top: 15px;
          color: #666;
          width: 100%;
        }

      }
      p.is-read{
        font-weight: 100;
      }
    }
    .item-action {
      color: #666;
      width: 40px;
      height: 30px;
      line-height: 30px;
      text-align: left;
      margin-top: 15px;
      .delete-icon {
        width: 32px;
        cursor: pointer;
        &:hover {
          color: #41a5fd;
        }
      }
      /deep/.tip-width {
        width: 230px;
      }
    }
  }
}
</style>
<style>
  .item-content p img{
      max-width: 100%;
      object-fit: fill;
  }
  .item-content p table{
    border: 1px solid #aaa;
  }
  .item-content p table{
    border-top: 1px solid #aaa;
    border-left: 1px solid #aaa;
    border-spacing: 0;
    border-collapse: collapse;
  }
  .item-content p table td{
    border-bottom: 1px solid #aaa;
    border-right: 1px solid #aaa;
    padding:5px;
  }

  .ivu-drawer-body img{
    max-width:100%;
    height:auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/member/message.vue